import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import { StateType, hasProjectAccess } from "client/utils"
import {
    PRM_CC_REVIEW,
    StoreType,
    CcReviewReviewProps,

    LoadCcReviewReviewItemById,
    LoadCcReviewReviewItemState,
    LoadCcReviewReviewHistory,

    setCcReviewReviewItemDetails,
    setCcReviewReviewItemState,
    setCcReviewReviewItemHistory,
    setCcReviewReviewReloadEdit,
    initReviewReviewItem,
    initReviewReviewItemState,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const ReviewReviewEdit = ({
    reviewItemId,
    revisionId,
}: CcReviewReviewProps) => {
    const activeFile = useSelector((state: StoreType) => state.ccReviewDocument.activeFile)
    const item = useSelector((state: StoreType) => state.ccReviewReview.itemDetails)
    const reloadEdit = useSelector((state: StoreType) => state.ccReviewReview.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcReviewReviewReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcReviewReviewReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (reviewItemId === 0) {
            dispatch(setCcReviewReviewItemDetails(initReviewReviewItem))
            dispatch(setCcReviewReviewItemState(initReviewReviewItemState))
            dispatch(setCcReviewReviewItemHistory([]))
            reload()
        } else {
            setLoadState(PENDING)
            Promise.all([
                LoadCcReviewReviewItemById(reviewItemId, activeFile.id).then((res) => {
                    dispatch(setCcReviewReviewItemDetails(res))
                }),
                LoadCcReviewReviewItemState(reviewItemId, revisionId).then((res) => {
                    dispatch(setCcReviewReviewItemState(res))
                }),
                LoadCcReviewReviewHistory(reviewItemId, revisionId).then((res) => {
                    dispatch(setCcReviewReviewItemHistory(res))
                }),
            ]).then(() => {
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const addAccess = hasProjectAccess(PRM_CC_REVIEW, ADD)
    const editAccess = hasProjectAccess(PRM_CC_REVIEW, EDIT)

    const allowedToEdit = editAccess || item.creator === userData.userId

    if (reviewItemId === 0 && !addAccess) return <AccessDenied />
    if (reviewItemId !== 0 && !allowedToEdit) return <AccessDenied />
    if (!item) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {item.id ? `${lang.editReviewItem} # ${item.id}` : lang.addReviewItem}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form item={item} revisionId={revisionId} />
                }
                {
                    reloadEdit
                    && <Form item={item} revisionId={revisionId} />
                }
            </PageContent>
        </Container>
    )
}
export default ReviewReviewEdit
